import axiosInstance from '../axiosInterceptor/axiosInstance'

const getStudioOperators = async (orgId) =>
  (await axiosInstance.get(`v1/orgs/${orgId}/studio/operators`))?.data

export default getStudioOperators
